angular.module('impactx.MenuDirectives').directive('ixCookieInfo', function () {
    return {
        restrict: 'E',
        templateUrl: 'shared/menu/templates/cookie-info.tmpl.html',
        controller: "CookieInfoCtrl",
        controllerAs: "cookieInfoCtrl"
    }
});